import STATE from './state';

import { createStore } from '@harlem/core';

const NAME = 'tags';

export const { state, getter, mutation } = createStore(NAME, STATE);
